// An utils that format a value using the provided callback when the value is truthy or a valid number, otherwise return '*'.
export function formatOrAnonymize(
  value: string | number | null | undefined,
  formatter: (value: string | number) => string
): string {
  if (value === null || value === undefined || value === '' || isNaN(+value) || !isFinite(+value)) {
    return '*';
  }

  return formatter(value);
}
